import type { SketchMeta } from './Sketch';
import { SKETCHES } from 'virtual:sketches';

/**
 * The sketch catalogue. Each entry is assembled at build time from its own
 * `src/sketches/<id>/meta.json` + lazy `load()` (see sketchesPlugin in
 * vite.config.ts) — there is no per-sketch data in this file.
 */
export { SKETCHES };

export function findSketch(id: string): SketchMeta | undefined {
  return SKETCHES.find((s) => s.id === id);
}
